import script from "./InsightCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InsightCard.vue?vue&type=script&setup=true&lang=js"

import "./InsightCard.vue?vue&type=style&index=0&id=3e02754c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e02754c"]])

export default __exports__